import React from 'react';
import SvgIcon from './SvgIcon';

const LockSolid = props => (
    <SvgIcon {...props}>
        <path
            d="M8 0C5.8 0 4 1.8 4 4v1H2c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1h-2V4c0-2.2-1.8-4-4-4zm1 11.7V13H7v-1.3c-.6-.3-1-1-1-1.7 0-1.1.9-2 2-2s2 .9 2 2c0 .7-.4 1.4-1 1.7zM10 5H6V4c0-1.1.9-2 2-2s2 .9 2 2v1z"
            fill="currentcolor"
            stroke="none"
        />
    </SvgIcon>
);

LockSolid.displayName = 'LockSolidIcon';

export default LockSolid;
